import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="bg-section-alt py-16 md:py-24 px-4" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-lg md:text-xl text-charcoal leading-relaxed font-body" data-id="element-84">
          <p data-id="element-85">
            Si hoy tocaste la puerta de su habitación y lo único que recibiste
            fue un "vete" o un silencio sepulcral, sabes exactamente de lo que
            hablo. Ese nudo en el estómago de sentir que has "perdido" a tu hijo
            dentro de tu propia casa es el dolor más profundo para un padre.
          </p>
          <p data-id="element-86">
            No es que no te quiera. No es que sea "flojo". Es que su cerebro
            está en modo de supervivencia, y cada vez que intentas ayudar con
            preguntas, él siente una invasión.
          </p>
        </motion.div>
      </div>
    </section>;
}